import React from 'react';
import BaseModal from '../../../Base/Components/BaseModal/BaseModal';
import { DiscourseItem } from '../DiscourseHistory/DiscourseHistoryItem';
import DiscourseSelectList from './DiscourseSelectList';
import { Size } from '../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	patientId: string;
	workplaceId: string;
	onSubmit: (item: DiscourseItem) => void;
}

const DiscourseSelectModal: React.FC<Props> = ({
	isOpen,
	onClose,
	patientId,
	workplaceId,
	onSubmit,
}) => {
	return (
		<BaseModal
			isOpen={isOpen}
			onClose={onClose}
			title='component.discourseSelect.title'
			contentScroll={false}
			contentStyle={{ padding: 0 }}
			size={Size.LG}>
			<DiscourseSelectList
				patientId={patientId}
				workplaceId={workplaceId}
				onSubmit={onSubmit}
			/>
		</BaseModal>
	);
};

export default DiscourseSelectModal;
